import axios from '@/plugins/axios'
import { MessageBox, Message } from 'element-ui'
import isEmpty from 'lodash/isEmpty'

export default {
  namespaced: true,

  state: {
    loading: false,
    tracks: [],
    dialog_form: false,
    dialog_deposit: false,
    active_label: null,
    active_campaign: {},
    track_list: [],
    track: {
      id: null,
      vc_rate: null,
      date_range: ''
    }
  },

  mutations: {
    setTrack(state, payload) {
      state.track = payload
    },
    setTracks(state, payload) {
      state.tracks = payload
    },
    setTrackDialog(state, status) {
      state.dialog_form = status
      state.track.id = null
      state.track.vc_rate = null
    },
    setTrackDeposit(state, status) {
      state.dialog_deposit = status
    },
    setActiveLabel(state, payload) {
      state.active_label = payload
    },
    setActiveCampaign(state, payload) {
      state.active_campaign = payload
    },
    setLoading(state, payload) {
      state.loading = payload
    },
    setTrackList(state, payload) {
      state.track_list = payload
    }
  },

  actions: {
    createTrack({ state, dispatch, commit }) {
      axios.artist
        .post(`campaign/${state.active_campaign.id}/track/create`, {
          sv_track_id: state.track.id,
          vc_start: state.track.date_range[0],
          vc_end: state.track.date_range[1]
        })
        .then(() => {
          commit('setTrackDialog', false)
          dispatch('readTracks')
        })
    },

    depositTrack({ state, dispatch, commit }, deposit) {
      MessageBox.confirm(
        `You will deposit ${deposit} VC to ${state.track.track.title} track. Continue?`,
        'Warning',
        {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }
      )
        .then(() => {
          axios.artist
            .post(
              `campaign/${state.active_campaign.id}/track/${state.track.id}/deposit/${deposit}`
            )
            .then(() => {
              commit('setTrackDeposit', false)
              dispatch('readTracks')
              dispatch('artistVidCents/readCampaign', null, { root: true })
            })
            .catch(err => {
              if (err.response.data && err.response.data.response.message) {
                Message({
                  type: 'error',
                  message: err.response.data.response.message
                })
              }
            })
        })
        .catch(() => {
          Message({
            type: 'info',
            message: 'Deposit cancelled'
          })
        })
    },

    readTracks({ state, commit }) {
      commit('setTracks', [])
      if (!isEmpty(state.active_campaign)) {
        commit('setLoading', true)
        axios.artist
          .get(`campaign/${state.active_campaign.id}/track`, {
            params: {
              artist:
                this.state.artistDashboard.artist_label !== null
                  ? this.state.artistDashboard.artist_label.id
                  : null
            }
          })
          .then(r => {
            commit('setTracks', r.data.data)
            commit('setLoading', false)
          })
          .catch(() => {
            commit('setTracks', [])
            commit('setLoading', false)
          })
      }
    },

    readTrackList({ commit }) {
      commit('setLoading', true)
      axios.artist
        .get('campaign/track', {
          params: {
            artist:
              this.state.artistDashboard.artist_label !== null
                ? this.state.artistDashboard.artist_label.id
                : null
          }
        })
        .then(r => {
          commit('setTrackList', r.data.data)
          commit('setLoading', false)
        })
        .catch(() => {
          commit('setTrackList', {})
          commit('setLoading', false)
        })
    }
  }
}
